import { Crown, Landmark, Star, TrendingUp, Globe2, Scale, Briefcase, PiggyBank, Users2 } from 'lucide-react';

export const NET_COLLECTIONS = {
    decideurs: { label: 'Décideurs', icon: Crown, color: 'bg-amber-100 text-amber-800 border-amber-200', isPerson: true },
    organisations: { label: 'Organisations', icon: Landmark, color: 'bg-blue-100 text-blue-800 border-blue-200', isPerson: false },
    contacts_premium: { label: 'Contacts Premium', icon: Star, color: 'bg-violet-100 text-violet-800 border-violet-200', isPerson: false },
    investisseurs: { label: 'Investisseurs', icon: TrendingUp, color: 'bg-emerald-100 text-emerald-800 border-emerald-200', isPerson: true },
    diplomatie: { label: 'Diplomatie', icon: Globe2, color: 'bg-cyan-100 text-cyan-800 border-cyan-200', isPerson: true },
    gouvernements: { label: 'Gouvernements', icon: Scale, color: 'bg-red-100 text-red-800 border-red-200', isPerson: true },
    entreprises: { label: 'Entreprises', icon: Briefcase, color: 'bg-orange-100 text-orange-800 border-orange-200', isPerson: true },
    banques_finance: { label: 'Banques & Finance', icon: PiggyBank, color: 'bg-teal-100 text-teal-800 border-teal-200', isPerson: true },
    diaspora: { label: 'Diaspora', icon: Users2, color: 'bg-rose-100 text-rose-800 border-rose-200', isPerson: true },
};

export const NET_STATUSES = {
    prospect: { label: 'Prospect', color: 'bg-stone-100 text-stone-700 border-stone-200' },
    contact: { label: 'Contact', color: 'bg-blue-50 text-blue-700 border-blue-200' },
    partenaire: { label: 'Partenaire', color: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
    ambassadeur: { label: 'Ambassadeur', color: 'bg-amber-50 text-amber-800 border-amber-200' },
};

// Champs spécifiques par collection (clé extra JSON → label formulaire/fiche)
export const NET_EXTRA_FIELDS = {
    decideurs: [
        ['categorie', 'Catégorie'], ['sous_categorie', 'Sous-catégorie'], ['nationalite', 'Nationalité'],
        ['langues', 'Langues'], ['domaines_expertise', 'Domaines d\'expertise'], ['offre_aeen', 'Offre AEEN recommandée'],
        ['angle_approche', 'Angle d\'approche'], ['type_evenement', 'Type d\'événement'], ['type_partenariat', 'Type de partenariat'],
    ],
    organisations: [
        ['type', 'Type'], ['secteur', 'Secteur'], ['budget_annuel', 'Budget annuel'], ['nb_employes', 'Nb employés'],
        ['date_creation', 'Date de création'], ['contact_principal', 'Contact principal'],
    ],
    contacts_premium: [['dernier_contact', 'Dernier contact']],
    investisseurs: [
        ['type_investisseur', 'Type d\'investisseur'], ['focus_geographique', 'Focus géographique'],
        ['secteurs_cibles', 'Secteurs cibles'], ['ticket_moyen_musd', 'Ticket moyen (M USD)'], ['aum_milliards_usd', 'AuM (Mds USD)'],
    ],
    diplomatie: [['pays_represente', 'Pays représenté'], ['type_mission', 'Type de mission'], ['adresse', 'Adresse']],
    gouvernements: [['parti', 'Parti politique'], ['date_nomination', 'Date de nomination']],
    entreprises: [['secteur', 'Secteur'], ['presence_afrique', 'Présence Afrique'], ['ca_milliards_eur', 'CA (Mds EUR)']],
    banques_finance: [['type_institution', 'Type d\'institution'], ['couverture_afrique', 'Couverture Afrique'], ['actifs_milliards_usd', 'Actifs (Mds USD)']],
    diaspora: [['secteur', 'Secteur'], ['pays_origine', 'Pays d\'origine'], ['domaine_influence', 'Domaine d\'influence']],
};

export const SCORE_FIELDS_DECIDEURS = [
    ['score_niveau_decision', 'Niveau de décision'], ['score_pouvoir_economique', 'Pouvoir économique'],
    ['score_influence_internationale', 'Influence internationale'], ['score_interet_av360', 'Intérêt AV360'],
    ['score_accessibilite', 'Accessibilité'], ['score_pertinence_afrique_europe', 'Pertinence Afrique-Europe'],
    ['score_visibilite_publique', 'Visibilité publique'], ['score_fiabilite_info', 'Fiabilité info'], ['score_reseau', 'Réseau'],
];
